import { useCallback } from 'react'

import styles from './TxnDrillDown.module.css'

export interface MonthOption {
  label: string
  /** Calendar month number, or null for "All". */
  value: number | null
  disabled?: boolean
}

function MonthChip({
  option,
  selected,
  onSelect,
}: {
  option: MonthOption
  selected: boolean
  onSelect: (value: number | null) => void
}) {
  const handleClick = useCallback(() => onSelect(option.value), [onSelect, option.value])
  return (
    <button
      type="button"
      className={styles.chip}
      aria-pressed={selected}
      disabled={option.disabled}
      onClick={handleClick}
    >
      {option.label}
    </button>
  )
}

export function MonthChips({
  options,
  value,
  onChange,
}: {
  options: MonthOption[]
  value: number | null
  onChange: (value: number | null) => void
}) {
  return (
    <div className={styles.months} role="group" aria-label="Filter by month">
      {options.map((option) => (
        <MonthChip key={option.label} option={option} selected={option.value === value} onSelect={onChange} />
      ))}
    </div>
  )
}
